import React, { Component } from 'react';

class WorkExp extends React.Component {
	render() {
		return (
			<div>
			<p>
			<h2>GE Healthcare</h2> 	
			<p>Senior Data Engineer 	 Oct. 2016 – Dec. 2016</p>
			<h4>•	Developed modules to ingest batched log files (in different formats) of various medical devices using Hadoop (Sqoop, Hive)</h4>
			<h4>•	Parsed the data using UDFs in Java and persisted structured data in Greenplum database for running Prescriptive Analytics </h4>
			</p>

			<p>
			<hr/>
			<p> Software Engineer     July 2014 – Oct. 2016</p>
			<h3> Remote Healthcare </h3>
			<h4>•	Built RESTful APIs using Spring Boot and UI using React JS & Redux framework; Followed Agile with bi-weekly sprints </h4> 
			<h4>•	Designed a rule-engine based on protocols configured in JSON and built a subscriptions handling framework using ActiveMQ</h4>
			<h4>•	Developed offline app. capability using Service Workers and built SMS service module by assessing 3rd party SMS gateways</h4>
			<h4>•	Wrote Junit and integration test cases using Mockito framework</h4>
			<h4>•	Refactored code to fix critical issues using SonarQube and used Jenkins for CI & CD of application on AWS EC2 instance </h4>
			<h3> Virtual Tumor Board </h3>
			<h4>•	Conducted market research to understand oncology workflow and scope requirements from top 10 healthcare providers</h4>
			<h4>•	Independently developed and deployed a standalone web app. using Angular JS 1.x, Play-Framework (Java), Hibernate / JPA</h4>
			<h4>	-	Built webRTC (VoIP) features to virtually-connect doctors; Developed a dynamic form builder saving $3000 p.a. per setup </h4>
			<h4>	-	Proposed a technical design and optimized interoperability across information systems using HL7 standardization</h4>
			<h4>•	Achieved 2 grants of $300,000 & $500,000 from ASEAN CEO to scale product and team</h4>
			<h4>•	Managed a team of 6 engineers functioning as Lead Software Engineer; Applauded with 2 awards for the impact on project</h4>



			</p>	

			</div>
			);
	}
} 

export default WorkExp;


// WEBPACK FOOTER //
// ./src/writeups/workexp.js